import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCloudBenefitModal from "../view/FJCloudBenefitModal";
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import {FJModalAction, FJPaymentAction} from "../../../redux/action/FJRoot.action";

class FJConfirmModalContainer extends Component {
  render() {
    let {
      visible,
      upgrade,
      hide
    } = this.props;
    return (
      <FJCommonModal visible={visible}
                     width='802px'
                     hasOuterCloseBtn={true}
                     onCancel={hide}
      >
        <FJCloudBenefitModal upgrade={upgrade}/>
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowCloudBenefitModal,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    upgrade: function (source) {
      dispatch(FJModalAction.setIsShowCloudBenefitModalAction(false));
      dispatch(FJPaymentAction.upgradeLevelAction(source));
    },
    hide: function () {
      dispatch(FJModalAction.setIsShowCloudBenefitModalAction(false));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJConfirmModalContainer);
